import React, { useState } from 'react';

const NoDataFoundPopupHOC = (Component:any) => 
function Comp(props:any){
    const [showNoDataFoundPopup,setShowNoDataFoundPopup] = useState<boolean>(false);

    const noDataFoundToggleHandler = () => {
        setShowNoDataFoundPopup(!showNoDataFoundPopup);
    }
	
	return <Component showNoDataFoundPopup={showNoDataFoundPopup} noDataFoundPopupToggleHandler={noDataFoundToggleHandler} {...props}/>;
};

export default NoDataFoundPopupHOC;   